module.exports = __webpack_public_path__ + "static/media/project-logo.67099229.jpg";